import { ContainerComponent } from "../../ui";
import FooterBottomComponent from "../FooterBottomComponent";
import FooterTopComponent from "../FooterTopComponent";
import { Wrapper } from "./style";

const FooterComponent = () => {
  return (
    <Wrapper>
      <ContainerComponent>
        <FooterTopComponent />
        <FooterBottomComponent />
      </ContainerComponent>
    </Wrapper>
  );
};

export default FooterComponent;
